import * as React from 'react'
import { cn } from '@/models/app/lib/utils'
import {
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuTrigger,
} from '@/components/ui/navigation-menu'
import AppNavbarLink from './app-navbar-link'

interface NavbarSection {
  title: string
  items?: Array<{ title: string, href: string }>
  href?: string
  description?: string
}

interface NavbarDropdownMenuProps {
  title: string
  sections: NavbarSection[]
  value?: string
}

export default function NavbarDropdownMenu({
  title,
  sections,
  value,
}: NavbarDropdownMenuProps) {
  const [hoveredSection, setHoveredSection] = React.useState(0)

  const activeSection = sections[hoveredSection]

  return (
    <NavigationMenuItem value={value}>
      <NavigationMenuTrigger>{title}</NavigationMenuTrigger>
      <NavigationMenuContent>
        <div className="grid w-[475px] grid-cols-5 gap-4 divide-x p-4">
          <div className="col-span-2 space-y-2 pr-4">
            {sections.map((section, index) => (
              <button
                type="button"
                key={section.title}
                className={cn(
                  'group mb-1 w-full rounded-md px-4 py-2 text-left transition-colors duration-300 ease-in-out',
                  'hover:bg-accent/80',
                  hoveredSection === index && 'bg-accent/50 !rounded-lg',
                )}
                onMouseEnter={() => setHoveredSection(index)}
                onClick={() => setHoveredSection(index)}
              >
                <h4 className={cn(
                  'items-center transition-colors duration-300 ease-in-out',
                  hoveredSection === index ? 'text-primary' : '!text-muted-foreground',
                  'group-hover:text-primary',
                )}
                >
                  {section.title}
                </h4>
              </button>
            ))}
          </div>
          <div className="col-span-3">
            {activeSection?.items && (
              <div className="space-y-2">
                {activeSection.items.map(item => (
                  <AppNavbarLink
                    key={item.title}
                    href={item.href}
                  >
                    {item.title}
                  </AppNavbarLink>
                ))}
              </div>
            )}
          </div>
        </div>
      </NavigationMenuContent>
    </NavigationMenuItem>
  )
}
